import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import OsXInvoiceForm from '@/components/Reports/MovementReports/OsxInvoice/OsXInvoiceForm';
import { useGenerateWorkOrderByInvoice } from '@/core/domain/reports/workOrderReport/workOrderReport.hooks';
import { GenereteWorkOrderByInvoiceFormValues } from '@/core/domain/reports/workOrderReport/workOrderReport.types';
import useFileLoading, { FILE_FORMAT, FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { useReportHandlers } from '@/hooks/useReportHandler';
import { PageProps } from '@/types/PageProps';
import { Divider, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function MovementOsXInvoicePage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<GenereteWorkOrderByInvoiceFormValues>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();
  const generateReport = useGenerateWorkOrderByInvoice();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      const values = await form.validateFields();

      const result = await generateReport.mutateAsync({
        ...values,
        format: FILE_FORMAT[format],
        initialDate: values.initialDate.format('YYYY-MM-DD'),
        finalDate: values.finalDate.format('YYYY-MM-DD'),
        companiesIds: values.companiesIds?.toString(),
      });

      if (callback) {
        callback(result);
      }
    } finally {
      setFileUnloading(format);
    }
  };

  const { handleView, handlePdf } = useReportHandlers(
    'relatorio-os-x-nota-fiscal',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <OsXInvoiceForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
